import { createFileRoute, useLoaderData } from "@tanstack/react-router";

import { orgApiClient } from "@/libs/api/org-client";

import { OrgPage } from "../-components/org.preview";

export const Route = createFileRoute("/org/$orgId/preview")({
  component: () => Page(),
  loader: async ({ params }) => {
    const org = await orgApiClient.getOne(params.orgId);
    return { data: { org } };
  }
});

function Page() {
  const { data } = useLoaderData({ from: "/org/$orgId/preview" });
  const { org } = data;
  if (!org) {
    return <div>Org not found</div>;
  }
  return <OrgPage org={org} />;
}
